export default __webpack_public_path__ + "static/Nike-58e25d2d6729df6340fd28183b7b0e59.png";